export const FAQ_CATEGORIES = 'FAQ_CATEGORIES';
export const FAQS_WITH_CATEGORY_ID = 'FAQS_WITH_CATEGORY_ID';
export const FAQS_WITH_SEARCH = 'FAQS_WITH_SEARCH';